import React from "react";
import styles from "./KioskShopItem.module.css";
import { useSelector } from "react-redux";
import { promotionTypes } from "config/promotionTypes";
import placeholder360x225 from "assets/placeholder/360x225.png";

const KioskShopItem = ({ logo, title, promotionTag, floorName, slot }) => {
  const langState = useSelector((state) => state.language.lang);

  return (
    <div className={styles.ShopItem}>
      <div className={styles.ShopItemImage}>
        <img
          src={logo || placeholder360x225}
          alt={title}
          className="img-fluid"
        />
      </div>

      {promotionTag && promotionTag != 0 && (
        <img
          src={promotionTypes[langState][promotionTag]}
          alt="promotion"
          className={`${styles.promotion} ${
            promotionTag === "new" ? styles.new : ""
          }`}
        />
      )}
      <div className={styles.ShopLot}>{floorName} - {slot}</div>
    </div>
  );
};

export default KioskShopItem;
